import { Box, Button, Icon, Text } from '@chakra-ui/react';
import React from 'react';
import { MdPhone } from 'react-icons/md';
import { RiLogoutBoxRFill } from 'react-icons/ri';
import { useLogout } from '../../lib/auth-provider/context/hooks';
const SubcriptionExpire = () => {
  const [logout] = useLogout();

  return (
    <Box minHeight={'100vh'} p={4}>
      <Button
        fontSize="sm"
        height="36px"
        lineHeight={5}
        variant="ghost"
        color="gray.600"
        iconSpacing="12px"
        fontWeight="medium"
        colorScheme="blue"
        justifyContent="start"
        leftIcon={
          <Icon as={RiLogoutBoxRFill} color="gray.400" w="12px" h="12px" />
        }
        type="button"
        onClick={logout}
      >
        Logout
      </Button>

      <Box
        pt={16}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Box
          height={'200px'}
          width={'200px'}
          bg={'#E8F7FD'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          borderRadius={'100%'}
          color={'teal'}
        >
          {/* <MdLockOutline height={'236px'} width={'236px'} /> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="140"
            height="140"
            viewBox="0 0 236 236"
            fill="none"
          >
            <path
              d="M177 83.5833H167.167V63.9167C167.167 36.7767 145.14 14.75 118 14.75C90.8599 14.75 68.8333 36.7767 68.8333 63.9167V83.5833H58.9999C48.1833 83.5833 39.3333 92.4333 39.3333 103.25V201.583C39.3333 212.4 48.1833 221.25 58.9999 221.25H177C187.817 221.25 196.667 212.4 196.667 201.583V103.25C196.667 92.4333 187.817 83.5833 177 83.5833ZM88.4999 63.9167C88.4999 47.5933 101.677 34.4167 118 34.4167C134.323 34.4167 147.5 47.5933 147.5 63.9167V83.5833H88.4999V63.9167ZM177 201.583H58.9999V103.25H177V201.583ZM118 172.083C128.817 172.083 137.667 163.233 137.667 152.417C137.667 141.6 128.817 132.75 118 132.75C107.183 132.75 98.3333 141.6 98.3333 152.417C98.3333 163.233 107.183 172.083 118 172.083Z"
              fill="#00A3BF"
            />
          </svg>
        </Box>
        <Text
          mt={'54px'}
          color={'teal'}
          fontWeight={'semibold'}
          fontSize={'25px'}
          textAlign={'center'}
        >
          Anda tidak dapat melanjutkan Pemakaian aplikasi ini
        </Text>
        <Text
          mt={'25px'}
          maxWidth={'500px'}
          fontSize={'17px'}
          textAlign={'center'}
        >
          Masa berlaku anda sudah habis. Silahkan menghubungi Operator Ezzi
          School Apps agar dapat berlaku kembali
        </Text>
        <Box
          maxW={'400px'}
          mt={'20px'}
          display={'flex'}
          justifyContent={'space-between'}
          color={'teal'}
          gap={'0px 17px'}
        >
          <Box display={'flex'} gap={'0px 10px'} alignItems={'center'}>
            <Box
              height={'30px'}
              width={'30px'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              borderRadius={'100%'}
              bg={'#E8F7FD'}
            >
              <MdPhone />
            </Box>
            <Text
              as={'a'}
              href="https://wa.me/6285155094959"
              target="_blank"
              _hover={{ color: 'teal' }}
              color={'black'}
            >
              085155094959
            </Text>
          </Box>
          <Box display={'flex'} gap={'0px 10px'} alignItems={'center'}>
            <Box
              bg={'#E8F7FD'}
              height={'30px'}
              width={'30px'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              borderRadius={'100%'}
            >
              <MdPhone />
            </Box>
            <Text color={'black'}>Operatorezzisekolah@gmail.com</Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SubcriptionExpire;
